import Product from './Product';

const Category = ({columnFilter, colSpan, products}) => (
    <tbody className="product-category">
        {products.map(product => (
            <Product
                {...product}
                key={product.id}
                columnFilter={columnFilter}
            />
        ))}
        <tr className="product-category-spacer">
            <td colSpan={colSpan} />
        </tr>
    </tbody>
);

export default Category;
